import SideMenu from "components/SideMenu";
import { WordpressSection } from "components/Wordpress/WordpressSection";
import { UptimeSection } from "components/Maintenance/UptimeSection";
import { SecuritySection } from "components/Maintenance/SecuritySection";
import { IntegrationsSection } from "components/Maintenance/IntegrationsSection";
import { RecommendationsSection } from "components/Maintenance/RecommendationsSection";
import { useAuth } from "providers/auth.provider";
import { useSite } from "providers/site.provider";
import { useEffect, useState } from "react";
import { getWordpressData } from "services/apf-api.service";
import { IWordpress } from "interfaces/IWordpress.interface";

export const Maintenance = () => {
  const { selectedSite } = useSite();
  const { idToken } = useAuth();

  const [wordpress, setWordpress] = useState<IWordpress | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedSite && idToken) {
        // Replace with actual API call
        if (selectedSite.integrations.includes("wp")) {
          setWordpress(await getWordpressData(selectedSite.id, idToken));
        }
      }
    };
    fetchData();
  }, [selectedSite, idToken]);

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-[240px_1fr]">
      <SideMenu />
      <main className="p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between gap-3">
          <div>
            <div className="text-sm text-muted-foreground">Maintenance</div>
            <h1 className="text-2xl font-semibold tracking-tight">
              {selectedSite?.name}
            </h1>
          </div>
        </div>

        {/* Sections */}
        {wordpress && <WordpressSection wordpress={wordpress} />}

        <UptimeSection refId={selectedSite?.id} />
        <SecuritySection />
        <IntegrationsSection integrations={selectedSite?.integrations} />
        <RecommendationsSection />
      </main>
    </div>
  );
};
